import { render, staticRenderFns } from "./ContainerBlock.vue?vue&type=template&id=89baecb6&scoped=true"
import script from "./ContainerBlock.vue?vue&type=script&lang=js"
export * from "./ContainerBlock.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "89baecb6",
  null
  
)

export default component.exports